import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function TermsPage() {
  return <>
      <Navigation data-id="element-477" />

      <main className="wrap report-main" data-id="element-478">
        <article className="report" data-id="element-479">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-480">
            <div className="fm-cell" data-id="element-481">
              <span className="lbl" data-id="element-482">Document</span>
              <span className="val" data-id="element-483">Terms of Service</span>
            </div>
            <div className="fm-cell" data-id="element-484">
              <span className="lbl" data-id="element-485">Updated</span>
              <span className="val" data-id="element-486">January 2026</span>
            </div>
            <div className="fm-cell" data-id="element-487">
              <span className="lbl" data-id="element-488">Status</span>
              <span className="val" data-id="element-489">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" data-id="element-490">
            <div className="kicker" data-id="element-491">Andoe / Legal</div>
            <h1 data-id="element-492">Terms of Service</h1>
            <p className="lede" data-id="element-493">
              These Terms of Service govern your access to and use of Andoe,
              including our website, dashboards, reports, and related software.
            </p>
            <p className="abstract" data-id="element-494">
              By creating an account, accessing, or using the Service, you agree
              to these Terms. If you do not agree, do not use the Service. If
              you are using the Service on behalf of a company, you represent
              that you have authority to bind that organization to these Terms.
            </p>
          </section>

          <section className="report-section" data-id="element-495">
            <div className="section-head" data-id="element-496">
              <div className="section-num" data-id="element-497">01</div>
              <div className="section-title" data-id="element-498">
                <h2 data-id="element-499">Who We Are & Eligibility</h2>
                <span className="deck" data-id="element-500">The basics of the agreement.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-501">
              <div className="pad" data-id="element-502"></div>
              <div className="content" data-id="element-503">
                <div className="entry" data-id="element-504">
                  <p data-id="element-505">
                    Andoe is operated by Grey Timbre AI Ltd ("Company"). We
                    provide an analytics platform as a service designed to help
                    users understand how brands and content appear in
                    AI-generated answers.
                  </p>
                </div>
                <div className="entry" data-id="element-506">
                  <h3 data-id="element-507">Account Types</h3>
                  <p data-id="element-508">
                    <strong data-id="element-509">Air Plan:</strong> Available to individuals for
                    personal or professional use. You are responsible for all
                    activity under your account.
                  </p>
                  <p style={{
                  marginTop: '8px'
                }} data-id="element-510">
                    <strong data-id="element-511">Pro Plan:</strong> Intended for businesses, teams,
                    and organizations. Your organization is responsible for all
                    use under its account(s).
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-512">
            <div className="section-head" data-id="element-513">
              <div className="section-num" data-id="element-514">02</div>
              <div className="section-title" data-id="element-515">
                <h2 data-id="element-516">Acceptable Use</h2>
                <span className="deck" data-id="element-517">Rules for using the Service.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-518">
              <div className="pad" data-id="element-519"></div>
              <div className="content" data-id="element-520">
                <div className="entry" data-id="element-521">
                  <p data-id="element-522">
                    You agree to use Andoe only for lawful purposes. You may
                    not:
                  </p>
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-523">
                    <li data-id="element-524">
                      Reverse engineer, decompile, or attempt to extract source
                      code or models
                    </li>
                    <li data-id="element-525">Bypass safeguards, rate limits, or access controls</li>
                    <li data-id="element-526">
                      Build a competing product or benchmark without written
                      consent
                    </li>
                    <li data-id="element-527">Violate any law, regulation, or third-party rights</li>
                    <li data-id="element-528">
                      Upload unlawful, misleading, defamatory, or harmful
                      content
                    </li>
                    <li data-id="element-529">
                      Interfere with or disrupt the Service infrastructure
                    </li>
                  </ul>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-530">
                    We may suspend or terminate access if we believe these rules
                    have been violated.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-531">
            <div className="section-head" data-id="element-532">
              <div className="section-num" data-id="element-533">03</div>
              <div className="section-title" data-id="element-534">
                <h2 data-id="element-535">Data, Inputs & Outputs</h2>
                <span className="deck" data-id="element-536">Ownership and usage rights.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-537">
              <div className="pad" data-id="element-538"></div>
              <div className="content" data-id="element-539">
                <div className="entry" data-id="element-540">
                  <h3 data-id="element-541">Your Inputs</h3>
                  <p data-id="element-542">
                    You retain ownership of the data and prompts you submit
                    ("Inputs"). You grant Andoe a limited right to host,
                    process, and analyze Inputs solely to operate the Service
                    and generate reports for you. We do not sell your Inputs.
                  </p>
                </div>
                <div className="entry" data-id="element-543">
                  <h3 data-id="element-544">Outputs and Insights</h3>
                  <p data-id="element-545">
                    The Service generates analytics and recommendations
                    ("Outputs") for informational purposes only. Outputs may be
                    inaccurate, incomplete, or affected by third-party changes.
                    You are solely responsible for how you interpret and use
                    Outputs.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-546">
            <div className="section-head" data-id="element-547">
              <div className="section-num" data-id="element-548">04</div>
              <div className="section-title" data-id="element-549">
                <h2 data-id="element-550">Third-Party Services</h2>
                <span className="deck" data-id="element-551">
                  Interactions with external platforms.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-552">
              <div className="pad" data-id="element-553"></div>
              <div className="content" data-id="element-554">
                <div className="entry" data-id="element-555">
                  <p data-id="element-556">
                    Andoe relies on third-party services, APIs, and models
                    (e.g., LLM providers, search engines). These are not under
                    our control and may change or become unavailable. We are not
                    responsible for their availability, accuracy, or changes to
                    AI models or ranking behavior.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-557">
            <div className="section-head" data-id="element-558">
              <div className="section-num" data-id="element-559">05</div>
              <div className="section-title" data-id="element-560">
                <h2 data-id="element-561">Billing & Subscriptions</h2>
                <span className="deck" data-id="element-562">Payments and cancellation.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-563">
              <div className="pad" data-id="element-564"></div>
              <div className="content" data-id="element-565">
                <div className="entry" data-id="element-566">
                  <p data-id="element-567">
                    Paid plans are billed in advance and automatically renew
                    unless canceled. You may cancel at any time; cancellation
                    takes effect at the end of the current billing period and
                    fees are non-refundable. You are responsible for applicable
                    taxes.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-568">
            <div className="section-head" data-id="element-569">
              <div className="section-num" data-id="element-570">06</div>
              <div className="section-title" data-id="element-571">
                <h2 data-id="element-572">Disclaimers & Liability</h2>
                <span className="deck" data-id="element-573">Legal limitations.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-574">
              <div className="pad" data-id="element-575"></div>
              <div className="content" data-id="element-576">
                <div className="entry" data-id="element-577">
                  <h3 data-id="element-578">Disclaimers</h3>
                  <p data-id="element-579">
                    The Service is provided "as is" and "as available." We
                    disclaim all warranties, including fitness for a particular
                    purpose, accuracy of Outputs, and uninterrupted operation.
                    We cannot guarantee that your brand visibility or rankings
                    will improve.
                  </p>
                </div>
                <div className="entry" data-id="element-580">
                  <h3 data-id="element-581">Limitation of Liability</h3>
                  <p data-id="element-582">
                    Andoe will not be liable for indirect, incidental, special,
                    or consequential damages, or loss of profits or data. Our
                    total liability will not exceed the fees you paid to Andoe
                    in the 12 months prior to the claim.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-583">
            <div className="section-head" data-id="element-584">
              <div className="section-num" data-id="element-585">07</div>
              <div className="section-title" data-id="element-586">
                <h2 data-id="element-587">Dispute Resolution</h2>
                <span className="deck" data-id="element-588">Arbitration and governing law.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-589">
              <div className="pad" data-id="element-590"></div>
              <div className="content" data-id="element-591">
                <div className="entry" data-id="element-592">
                  <p data-id="element-593">
                    You agree to try to resolve disputes informally first. If
                    unresolved, disputes will be resolved by binding
                    arbitration, rather than in court. You waive any right to
                    participate in a class action.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-594">
                    These Terms are governed by the laws of the Province of
                    British Columbia, Canada.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <Footer data-id="element-595" />
        </article>

        <pre className="json-view" data-id="element-596">
          {`// terms of service are for humans, not for AI to parse.
// 
// read the document above. it was written for you.`}
        </pre>
      </main>
    </>;
}